import React from 'react';
import { Theme } from '@lib/types';

export const getThemeStyles = (theme: Theme): React.CSSProperties => {
  switch (theme) {
    case Theme.DARK:
      return { backgroundColor: '#ECF0FD' }; // texto por defecto (oscuro)
    case Theme.BLUE:
      return {
        backgroundColor: '#0000FF',
        color: '#ffffff !important', // texto blanco para contraste
      };
    case Theme.LIGHT:
    default:
      return {
        background:
          'transparent linear-gradient(180deg, #FCCFD2 0%, #CDCCFE 100%) 0% 0% no-repeat padding-box',
      };
  }
};
